import { KeyboardEvent } from 'react';
import { Logo, cn } from '@c2fo/liquidity';

export interface NavigationHeaderProps {
  isCollapsed: boolean;
  isSubNavOpen: boolean;
  onClick?: () => void;
  href?: string;
  target?: string;
  rel?: string;
  as?: React.ElementType;
}

const NavigationHeader = (props: NavigationHeaderProps) => {
  const { isCollapsed, isSubNavOpen, onClick, href, target, rel, as, ...otherProps } = props;
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      onClick?.();
    }
  };

  const baseProps = {
    className: 'hidden md:block relative flex h-9 shrink-0 flex-col items-start justify-center',
    onClick,
    onKeyDown: handleKeyDown,
  };

  // determine component to render
  let Component: React.ElementType = 'div';
  let componentProps: Record<string, unknown> = {};

  if (as) {
    // use provided component with any additional props passed by consumer
    Component = as;
    componentProps = { ...otherProps };
  } else if (href) {
    // use anchor tag for external links
    Component = 'a';
    componentProps = { href, target, rel };
  } else if (onClick) {
    // use div with button semantics for click handlers
    componentProps = { role: 'button', tabIndex: 0 };
  }

  return (
    <Component {...baseProps} {...componentProps}>
      <Logo
        className={cn(
          'absolute left-4 top-1/2 h-fit w-20 shrink-0 grow-0 -translate-y-1/2 opacity-100',
          {
            'left-[60px] opacity-0': isCollapsed || isSubNavOpen,
          },
          'transition-all duration-200 ease-in-out'
        )}
      />
      <Logo
        brandMark
        className={cn(
          'absolute -left-[60px] top-1/2 h-fit w-6 shrink-0 grow-0 -translate-y-1/2 opacity-0',
          {
            'left-4 opacity-100': isCollapsed || isSubNavOpen,
          },
          'transition-all duration-200 ease-in-out'
        )}
      />
    </Component>
  );
};

export default NavigationHeader;
